var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.className,style:(_vm.styles),attrs:{"alt":_vm.title,"height":_vm.height,"src":_vm.url,"title":_vm.title,"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }